import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthenticationService } from './authentication.service';

@Injectable({ providedIn: 'root' })
export class ProfileDefaultGuard {
  constructor(private authenticationService: AuthenticationService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.authenticationService.getPlanFeaturesEnabled().pipe(
      map(plan => {
        const availableSkins = Array.isArray(plan?.available_dashboard_skins)
          ? plan.available_dashboard_skins : [];
        const skinSegments: Record<string, string> = {
          logistics: 'logistics',
          tax_accountancy: 'tax-accountancy',
          financial_services: 'financial-services',
        };
        const selectedSegment = availableSkins.includes(plan?.default_skin)
          ? skinSegments[plan.default_skin] : undefined;
        return selectedSegment
          ? this.router.createUrlTree(['/profile', route.paramMap.get('id'), selectedSegment], {
              queryParams: route.queryParams,
              fragment: route.fragment,
            })
          : true;
      }),
      catchError(() => of(true))
    );
  }
}
